/**
 * @file Created on Fri Jul 27 2018
 * @author VBr
 */
import Menu from './Menu';
export default Menu;